import styled from 'styled-components/native';

export const Display = styled.Text<{ important?: boolean }>`
    ${({ important }) => (important ? 'font-weight: bold; color: #000000' : '')};
`;
